import { Component, EventEmitter, OnInit, Optional, Output } from '@angular/core';
import { NbDialogRef, NbCardModule, NbSpinnerModule, NbAlertModule, NbButtonModule } from '@nebular/theme';

import { AssetHistoryService, SpreadsheetDialogManagerService } from '../../../@core/utils';
import { BaseHistoryDialogComponent } from '../base-history-dialog/base-history-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { HistoryListComponent } from '../history-list/history-list.component';


@Component({
    selector: 'app-asset-history-dialog',
    styleUrls: ['../base-history-dialog/base-history-dialog.component.scss'],
    templateUrl: '../base-history-dialog/base-history-dialog.component.html',
    standalone: true,
    imports: [
    NbCardModule,
    NbSpinnerModule,
    HistoryListComponent,
    NbAlertModule,
    NbButtonModule,
    TranslateModule
],
})
export class AssetHistoryDialogComponent extends BaseHistoryDialogComponent implements OnInit {

  @Output() isSubmit = new EventEmitter<boolean>();
  @Output() isClose = new EventEmitter<void>();

  public assetId: number;

  constructor(
    private assetHistoryService: AssetHistoryService,
    private dialogManagerService: SpreadsheetDialogManagerService,
    @Optional() public ref: NbDialogRef<AssetHistoryDialogComponent>
  ) {
    super();
  }

  public ngOnInit(): void {
    this.loading = true;
    this.error = false;
    if (!this.assetId) {
      this.assetId = this.dialogManagerService.inputData
    }

    this.subscriptions.push(
      this.assetHistoryService.loadHistoryForAsset(this.assetId).subscribe((hist) => {
        this.history = hist;
        this.loading = false;
      },
        () => {
          this.error = true;
          this.loading = false;
        }),
    );
  }

  public close(): void {
    this.isClose.emit();
    if (this.ref) {
      this.ref.close();
    }
  }
}
